const dateTimeLocale = navigator.language;

export const dateFormat = new Intl.DateTimeFormat(dateTimeLocale, {
    year: "numeric",
    day: "2-digit",
    month: "long",
});

export const dateTimeFormatMedium = new Intl.DateTimeFormat(dateTimeLocale, {
    dateStyle: "medium",
    timeStyle: "short",
});

export const dateFormatMedium = new Intl.DateTimeFormat(dateTimeLocale, {
    dateStyle: "medium",
});

export const dateFormatMediumUTC = new Intl.DateTimeFormat(dateTimeLocale, {
    dateStyle: "medium",
    timeZone: "UTC",
});

/**
 * Formats date and time in medium format, e.g. Apr 27, 2021, 8:31 AM
 */
export function formatMediumDateTime(date: Date): string {
    return date ? dateTimeFormatMedium.format(date) : "";
}

/**
 * Formats date in medium format, e.g. Apr 27, 2021
 */
export function formatMediumDate(date: Date | null): string {
    return date ? dateFormatMedium.format(date) : "";
}

/**
 * Formats date in medium format using UTC timezone, e.g. Apr 27, 2021
 * Use this when the date represents a UTC calendar date (e.g. payout dates)
 * to prevent local timezone offset from shifting the displayed day.
 */
export function formatMediumDateUTC(date: Date | null): string {
    return date ? dateFormatMediumUTC.format(date) : "";
}
